// TODO: Remove from `core-js@4`
require('./es.promise.any');



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/sanacorp/node_modules/core-js/modules/esnext.promise.any.js
// module id = 620
// module chunks = 0